import _ from "lodash";
import {
  getCPGradebookProjectGroupProjectsQuery,
  getCPGradebookProjectGroupProjectsWithStudentCollaboratorsQuery,
} from "./CPGradebookTableQueries";
import client from "lib/apolloClient/client";

export const getCPGradebookProjectGroupProjectsFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCPGradebookProjectGroupProjectsQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeCPGradebookProjectGroupProjectsInCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getCPGradebookProjectGroupProjectsQuery,
      variables,
      data: {
        node: data,
      },
    });
  } catch (e) {
    console.error("Error writing data to cache:", e);
  }
};

export const getCPGradebookProjectGroupProjectsWithStudentCollaboratorsFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCPGradebookProjectGroupProjectsWithStudentCollaboratorsQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeCPGradebookProjectGroupProjectsWithStudentCollaboratorsInCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getCPGradebookProjectGroupProjectsWithStudentCollaboratorsQuery,
      variables,
      data: {
        node: data,
      },
    });
  } catch (e) {
    console.error("Error writing data to cache:", e);
  }
};
